import moment from 'moment';
import User from 'helper/currentUser';

const user = new User();

export function getFormattedDuration(durationSecs, useShortFormsWithoutSpace) {
  const dur = moment.duration(durationSecs, 'seconds');
  const hrs = Math.floor(dur.asHours());
  const mins = Math.floor(dur.asMinutes() % 60);
  const secs = Math.floor(dur.asSeconds() % 60);
  let retStr = '';
  // console.log('mins::', mins, secs);
  const hourString = useShortFormsWithoutSpace ? 'h ' : ' h ';
  const minString = useShortFormsWithoutSpace ? 'm ' : ' min ';
  const secString = useShortFormsWithoutSpace ? 's ' : ' sec ';
  if (hrs > 0) {
    retStr = retStr + hrs + hourString;
  }
  if (mins > 0 || hrs > 0) {
    retStr = retStr + mins + minString;
  }
  // if(secs >= 0){
  //   retStr = retStr + secs +" s";
  // }
  // if (mins <= 0 && useShortFormsWithoutSpace) {
  //   retStr = durationSecs + secString;
  // }
  if (mins <= 0 && hrs <= 0 && useShortFormsWithoutSpace) {
    retStr = durationSecs + secString;
  } else if (mins <= 0 && hrs > 0 && useShortFormsWithoutSpace) {
    retStr = hrs + hourString + secs + secString;
  }
  return retStr;
}

export function getFormattedDuration1(durationSecs, useShortForms) {
  if (durationSecs === 0) {
    return '00:00 minutes';
  }
  const dur = moment.duration(durationSecs, 'seconds');
  const hrs = Math.floor(dur.asHours());
  let mins = Math.floor(dur.asMinutes() % 60);
  mins = mins < 9 ? '0' + mins : mins;
  let secs = Math.floor(dur.asSeconds() % 60);
  secs = secs < 9 ? '0' + secs : secs;
  let retStr = '';
  let unitString = ' hours';
  if (hrs > 0) {
    retStr = retStr + hrs + ':';
  }
  if (mins > 0) {
    if (hrs > 0) {
      retStr = retStr + mins + unitString;
      return retStr;
    }
    unitString = useShortForms ? ' min' : ' minutes';
    retStr = retStr + mins + ':';
  } else {
    retStr = retStr + mins + ':';
    unitString = useShortForms ? ' min' : ' minutes';
  }

  if (secs >= 0) {
    retStr = retStr + secs + unitString;
    return retStr;
  }
  return retStr;
}

export function getFormattedDurationInWords(durationSecs) {
  if (durationSecs === 0) {
    return '0 secs';
  }
  const dur = moment.duration(durationSecs, 'seconds');
  const hrs = Math.floor(dur.asHours());
  let mins = Math.floor(dur.asMinutes() % 60);
  mins = mins <= 9 ? '0' + mins : mins;
  let secs = Math.floor(dur.asSeconds() % 60);
  secs = secs <= 9 ? '0' + secs : secs;
  let retStr = '';
  const hrString = hrs > 1 ? ' hours' : ' hour';
  if (hrs > 0) {
    retStr += hrs;
  }
  const minString = mins > 1 ? ' minutes' : ' minute';
  if (mins > 0) {
    if (hrs > 0) {
      retStr += ':' + mins + hrString;
      return retStr;
    }
    retStr += mins + ':' + secs + minString;
  } else if (hrs > 0 && mins < 1) {
    retStr += hrString;
  } else {
    retStr += secs + ' seconds';
  }
  return retStr;
}

export function getFomattedDueDate(dateString, shortMonth) {
  if (dateString === -1) {
    return 'Invalid date';
  }
  if (shortMonth === true) {
    return moment(dateString).format('Do MMM');
  }
  return moment(dateString).format('Do MMMM');
}

/**
 * [getTimeHHmm description]
 * @param  {[type]} dateString   Possible formats http://momentjs.com/docs/#/displaying/format/
 */
export function getTimeHHmm(dateString, formatString) {
  if (dateString === -1 || dateString === '' || !dateString) {
    return '';
  }
  if (formatString) {
    return moment(dateString).format(formatString);
  }
  return moment(dateString).format('HH:mm');
}

export function getElapsedTime(dateString) {
  if (!moment(dateString).isValid()) {
    console.log('Invalid Date');
    return '';
  }
  return moment(dateString).fromNow();
}

export const defaultDateFormat = 'DD-MMM-YYYY hh:mm:ss A';
export const baseValidStartDate = '2015-01-01';

const sprinklrDateFormat = 'YYYY-MM-DD';

export const getDateFormat = () => {
  if (user.companyId() === '56bfef41a17441a959d9c8d5') {
    return sprinklrDateFormat;
  }
  return defaultDateFormat;
};
